import { render, staticRenderFns } from "./DataTracer.vue?vue&type=template&id=811038c0&scoped=true"
import script from "./DataTracer.vue?vue&type=script&lang=js"
export * from "./DataTracer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811038c0",
  null
  
)

export default component.exports